module.exports = __webpack_public_path__ + "static/media/ide-simu.988c0321.png";